<script setup>
import SecureTrustElement from '@/Components/Payments/SecureTrustElement.vue'
import { LibraryIcon, CreditCardIcon, XIcon, CashIcon } from '@heroicons/vue/outline'
import SaveCardForm from '@/Components/Payments/SaveCardForm.vue'
import BankForm from '@/Components/Payments/BankForm.vue'

import { ref, computed } from 'vue'
import { Inertia } from '@inertiajs/inertia'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()
import { usePaymentsStore } from '@/Stores/payments'
const payments = usePaymentsStore()

// convert the payment store state to refs so we can watch them and open the dialog
import { storeToRefs } from 'pinia'
const { showingSaveCardForm } = storeToRefs(payments)

// template refs
const dialog = ref(null) // so we can open and close it
let saveButton = ref(null)
let cardForm = ref(null)

function closeDialog() {
	payments.hideSaveCardForm()
}

document.addEventListener("keydown", (e) => {
	if (e.key === "Escape") {
		if( showingSaveCardForm.value ){
			closeDialog()
		}
	}
});

function cardSaved() {
	closeDialog()
	payments.fetchSavedCards()
}

function save(){
	saveButton.value.waitFor(cardForm.value.submitCardForm())
}

</script>

<template>
    <div 
		class="card-dialog fixed top-0 bottom-0 right-0 left-0 z-10 overflow-y-scroll" 
		v-if="showingSaveCardForm" 
		@click="closeDialog"
		data-testid="card-dialog"
	>
		<div class="save-card-dialog-inner rounded-md border absolute left-0 right-0 m-auto bg-white p-3 mt-12" @click.stop>
			<div class="w-full flex flex-col items-end -mb-6">
				<XIcon class="w-6 h-6 text-gray-500 cursor-pointer" @click="closeDialog" />
			</div>
			<div v-if="!auth.can('manage_payment_methods', 'organisations', payments.cardable_id)" class="text-center text-gray-500 py-12">
				User does not have permission to add payment methods
			</div>
			<div v-else>
				<Heading size="2">Add a payment method:</Heading>
				
				<Heading size="4">Enter a new credit card:</Heading>

				<SaveCardForm
					:cardable-type="payments.cardable_type"
					:cardable-id="payments.cardable_id"
					@card-saved="cardSaved"
					ref="cardForm"
				/>

				<PromiseButton
					ref="saveButton"
					@click="save"
					data-testid="save-button"
				>
					<CashIcon class="h-4 w-4 mr-2" /> Save
				</PromiseButton>
        	</div>
        </div>
    </div>
</template>

<style>
@media (min-width: 420px) {
	.save-card-dialog-inner {
		width: calc(370px + 4rem);
		padding: 2rem;
	}
}
</style>